import { useEffect } from "react";

const SITE = "https://btobpainting.ca";

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function Seo({ title, description, path, noindex = false }) {
    useEffect(() => {
        const url = path === "/" ? `${SITE}/` : `${SITE}${path}`;
        document.title = title;
        upsertMeta("name", "description", description);
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", url);
        if (noindex) upsertMeta("name", "robots", "noindex, nofollow");
        else upsertMeta("name", "robots", "index, follow, max-image-preview:large, max-snippet:-1");

        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);
    }, [title, description, path, noindex]);

    return null;
}
